var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHuobiWallet = function SvgHuobiWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "WalletConnect")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "14.2459714%",
    cy: "82.9640779%",
    fx: "14.2459714%",
    fy: "82.9640779%",
    r: "97.6569253%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C7CF8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u63A7\\u4EF6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u94B1\\u5305-Huobi",
    transform: "translate(-16.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WalletConnect",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u672A\\u547D\\u540D",
    fill: "url(#radialGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z",
    id: "\\u8DEF\\u5F84"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "heco"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.888889, 5.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77777778,6.56528272 C9.77777778,3.50266975 8.1802334,0.868073441 6.96574747,0.0102563438 C6.95996869,0.00845797311 6.87336379,-0.0382994199 6.88105745,0.0839888876 C6.88105745,0.0857875045 6.87913403,0.0857875045 6.87913403,0.0875861214 C6.77904815,6.00239441 3.54554242,7.60473067 1.7671117,9.76457253 C-2.33636671,14.7478573 1.4803265,20.2112381 5.36631388,21.2200883 C7.54123275,21.7847818 4.86396105,20.2202641 4.51943926,16.9148132 C4.10177646,12.9206857 9.77777778,9.87247313 9.77777778,6.56528272 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#2D3338",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2932296,8.01552828 C11.2668533,7.99856497 11.2303947,7.98734177 11.2040185,8.02675148 C11.1330817,8.80415072 10.275719,10.4677543 9.18934224,11.9942806 C5.50455525,17.1729727 7.60436459,19.6703485 8.78604691,21.0109638 C9.47110885,21.7902479 8.78604691,21.0109638 10.4987017,20.2148878 C10.6324734,20.1528604 13.8429923,18.4854872 14.1895742,14.6869058 C14.5280542,11.0085239 12.1424903,8.68960556 11.2932296,8.01552828 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#01943F",
    fillRule: "nonzero"
  }))))))));
};

export { SvgHuobiWallet as ReactComponent };
export default __webpack_public_path__ + "169b0c4ab228e9b8a580b834473a41ff.svg";